"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardProvider = exports.PropertyCardContext = void 0;
var _react = require("react");
/**
 * Used to control where data areas appear and how photos are treated
 */
var PropertyCardContext = /*#__PURE__*/(0, _react.createContext)({});
exports.PropertyCardContext = PropertyCardContext;
var PropertyCardProvider = PropertyCardContext.Provider;
exports.PropertyCardProvider = PropertyCardProvider;